import { TypeChecker } from '@attain-apps/type-guards'

import { Enum } from './enum'
import { Intrinsic } from './intrinsic'
import { Structure } from './structure'

export type Type<T = any> = Intrinsic.Of<T> | Enum | Structure
export namespace Type {
  export const isType: TypeChecker<Type> = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.union(
      Intrinsic.isIntrinsic,
      Enum.isEnum,
      Structure.isStructure,
    ),
  ).usingAlias('common.value.types.Type')
}
